const app = {
    errorHandler(error, reject) {
        if (error.response && error.response.data) {
            reject(error.response.data);
        } else {
            reject(error);
        }
    }
}

module.exports = app;